"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var hs_web_style_guide_1 = require("@headspace/hs-web-style-guide");

var barStyle = hs_web_style_guide_1.css({
  height: '8px',
  marginLeft: '1px',
  marginRight: '1px',
  display: 'inline-block',
  flex: '1 1 0',
  opacity: '0.2'
});

function ProgressBar(props) {
  var barColor = props.barColor,
      selected = props.selected;
  var barStyleExtended = hs_web_style_guide_1.css({
    opacity: selected ? '1' : '0.2',
    backgroundColor: barColor || '#000'
  });
  return React.createElement("li", __assign({}, barStyle, barStyleExtended));
}

exports.ProgressBar = ProgressBar;